import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { withTheme } from '@material-ui/core';
import {Modal as MaterialModal, Divider, Typography } from '@material-ui/core'
import { PrimaryButton, FlatButton } from './'

const styles = (theme: CentricTheme) => ({
  root: {
    position: 'absolute',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    borderRadius: 2,
    backgroundColor: theme.palette.background.default
  },
  header: {
    margin: theme.spacing() * 2
  },
  body: {
    margin: theme.spacing() * 2
  },
  footer: {
    display: 'flex',
    padding: '14px 8px',
    justifyContent: 'flex-end'
  },
  footerItem: {
    margin: '0px 8px'
  }
})

interface MyProps extends StyledProps {
  /** Content object having child node and title string */
  content?: {title?: React.ReactNode, body?: React.ReactNode},
  /** Boolean value indicating opening and closing of modal */
  open: boolean,
  /** Action to be performed on closing */
  handleClose?: (e) => void
  /** Action to be performed on submit button click */
  handleSubmit?: (e) => void
  /** Label for submit button */
  buttonLabel?: string
}

@(withStyles as any)(styles)
export class Modal extends React.Component<MyProps> {
  static defaultProps = {
    open:        false,
    buttonLabel: 'Save'}

  render() {
    const {className, classes, open, content = {}, handleClose, handleSubmit, buttonLabel} = this.props
    return (
      <MaterialModal open={open} onClose={handleClose} className={classNames(classes.root, className)}>
        <div className={classes.container}>
          <div className={classes.header}>
            <Typography variant='h5'>{content.title}</Typography>
          </div>
          <Divider/>
          <div className={classes.body}>{content.body}</div>
          <Divider/>
          <div className={classes.footer}>
            <FlatButton onClick={handleClose} className={classes.footerItem}>Cancel</FlatButton>
            <PrimaryButton onClick={handleSubmit} className={classes.footerItem}> {buttonLabel} </PrimaryButton>
          </div>
        </div>
      </MaterialModal>
    )
  }
}




// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Modal.tsx